import Paper from "@mui/material/Paper";
import { getNeuSurfaceStyles } from "../../theme/themeHelpers";

export default function NeuSurface({
  children,
  variant = "panel",
  sx = [],
  ...props
}) {
  return (
    <Paper
      elevation={0}
      {...props}
      sx={[
        (theme) => ({
          ...getNeuSurfaceStyles(theme, variant),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Paper>
  );
}